import { toast } from 'sonner';

import { getErrorMessage, isReportable, logError } from '@/shared/api/errors/apiErrors';
import { isApiError } from '@/shared/api/errors/errors';

import type { ReactNode } from 'react';

let renderReportAction: (err: unknown) => ReactNode = () => null;

export function setReportAction(render: (err: unknown) => ReactNode): void {
  renderReportAction = render;
}

function categoryIsReportable(err: unknown): boolean {
  return isApiError(err) && isReportable(err.errorCategory);
}

export function toastApiError(err: unknown, defaultMessage: string): void {
  const message = getErrorMessage(err, defaultMessage);

  if (isApiError(err) && err.status >= 500) {
    logError('api', err);
    toast.error(message, {
      duration: Infinity,
      action: renderReportAction(err),
    });
    return;
  }

  if (categoryIsReportable(err)) {
    toast.error(message, {
      duration: Infinity,
      action: renderReportAction(err),
    });
    return;
  }

  toast.error(message);
}
